// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowRightTwoRectangles } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-right-two-rectangles': IconArrowRightTwoRectangles;
    }
}

/**
 * The icon component for the 'arrowRightTwoRectangles' icon
 */
export class IconArrowRightTwoRectangles extends IconSvg {
    public constructor() {
        super(arrowRightTwoRectangles);
    }
}

registerIconSvg('icon-arrow-right-two-rectangles', IconArrowRightTwoRectangles);
export const iconArrowRightTwoRectanglesTag = 'nimble-icon-arrow-right-two-rectangles';
